export default __webpack_public_path__ + "static/solderingiron-8035e499cdc120a3364dce61d7729e50.png";